<template>
  <div>
    <div class="bg" style="padding-bottom: 20px">
      <FxedTop></FxedTop>
    </div>
    <div class="page" style="width: 1200px; margin: 0 auto">
      <div class="pageTitle" style="width: 1200px">
        <el-button class="btn" type="primary" plain @click="navback">
          返回
        </el-button>
        <div>您正在浏览： 我的证书</div>
      </div>
      <template v-if="list.length > 0">
        <!-- 水印容器 -->
        <div class="watermark-container">
          <div class="watermark" v-for="i in 12" :key="'wm-' + i">
            {{ watermarkText }}
          </div>
        </div>

        <div id="printPdfpage" ref="printPdfpage">
          <div class="printPdfpage">
            <img style="width: 100%; margin-bottom: 10px" src="@/assets/image/xzzjzs.png" />
            <div class="title">
              {{ list[index].classYear }}年西藏自治区专业技术人员继续教育{{
                typeName
              }}科目培训合格证书
            </div>
            <!-- 第一行 -->
            <div class="row1">
              <div style="margin-right: 150px">
                姓名: {{ list[index].studentName }}
              </div>
              <div style="margin-right: 150px">
                性别: {{ list[index].gender == 1 ? "男" : "女" }}
              </div>
              <div>联系电话: {{ list[index].phoneNumber }}</div>
            </div>
            <div class="row2">
              <div style="margin-right: 150px">
                身份证号: {{ list[index].idCardNo }}
              </div>
              <div style="margin-right: 150px">
                职称:
                {{
                  list[index].professionalTitle == 1
                    ? "初级"
                    : list[index].professionalTitle == 2
                      ? "中级"
                      : list[index].professionalTitle == 3
                        ? "高级"
                        : "未评"
                }}
              </div>
            </div>
            <!-- <div v-if="typeName != '公需'" class="row3">
              <div style="margin-right: 150px">
                所属专业系列: {{ getXw_XlName("zy", list[index].majorCode) }}
              </div>
            </div> -->
            <div :class="typeName == '公需' ? 'row3' : 'row3'">
              <div style="margin-right: 150px">
                所属组织: {{ list[index].schoolName }}
              </div>
            </div>
            <template v-if="typeName == '公需'">
              <div class="row4">
                <div style="margin-right: 150px">
                  必修课程已修学时:
                  {{ list[index].requiredCourseHour }}
                </div>
              </div>
              <div class="row5">
                <div style="margin-right: 150px">
                  选修课程已修学时:
                  {{ list[index].optionalCourseHour }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row4">
                <div style="margin-right: 150px">
                  线上培训已修学时:
                  {{
                    list[index].requiredCourseHour +
                    list[index].optionalCourseHour
                  }}
                </div>
              </div>
            </template>

            <div :class="typeName == '公需' ? 'row6' : 'row5'">
              <div style="margin-right: 150px">
                {{ list[index].classYear }}年西藏自治区专业技术人员继续教{{
                  typeName
                }}科目共计获得:
                {{
                  list[index].requiredCourseHour +
                  list[index].optionalCourseHour
                }}
                学时
              </div>
            </div>
            <!-- 二维码 -->
            <canvas ref="certificateQrCanvas" class="certificateQrCanvas" style="width: 100px; height: 100px"></canvas>
          </div>
        </div>
        <div class="button-container">
          <div @click="print" class="print jrwdkc2">打印预览</div>
          <div @click="generatePDF" class="print jrwdkc2">下载PDF</div>
        </div>
      </template>
      <div v-else class="zhanwu">
        由于学时不够, 暂时无法查看和下载证书,
        <span @click="toCourse">请点击→【继续学习】获取更多学时</span>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
import { getMyCertificate, saveCertificateDownload } from "@/api/wkApi";
import { getUserInfo } from "@/api/user";
import printJS from "print-js";
import html2canvas from "html2canvas";
// 导入jspdf
import { jsPDF } from "jspdf";
import QRCode from "qrcode";

import new_json_xl from "@/assets/json/new_json_xl";
import new_json_xw from "@/assets/json/new_json_xw";
import json_zy from "@/assets/json/json_zy";
export default {
  components: {
    FxedTop,
    Footer,
  },
  data() {
    return {
      new_json_xl,
      new_json_xw,
      json_zy,
      list: [],
      index: 0,
      userInfo: {},
      qrcodeUrl: "",
      ciphertext: "",
      options: {},
      typeName: "",
    };
  },
  computed: {
    watermarkText() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day} ${window.location.origin}/pc/#/`;
    },
  },
  created() {
    this.options = this.$route.query;
    if (this.options.type == 1) {
      this.typeName = "公需";
    } else {
      this.typeName = "专业";
    }
    this.getMyCertificate();
    this.getUserInfo();
  },
  methods: {
    getXw_XlName(type, code) {
      let name = "";
      if (type == "zy") {
        this.json_zy.forEach((item) => {
          if (item.code == code) {
            name = item.value;
          }
          if (item.sub.length > 0) {
            item.sub.forEach((itemm) => {
              if (itemm.code == code) {
                name = itemm.value;
              }
              if (itemm.sub.length > 0) {
                itemm.sub.forEach((itemmm) => {
                  if (itemmm.code == code) {
                    name = itemmm.value;
                  }
                });
              }
            });
          }
        });
      }
      return name;
    },
    // 时间格式 2025-04-17 00:53:00  转换成 2025年4月7日
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}年${month}月${day}日`;
    },
    navback() {
      this.$router.go(-1);
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        this.userInfo = res.data;
        console.log(res);
      });
    },
    prev() {
      this.index--;
      if (this.index < 0) {
        this.$message.error("已经是第一页了");
        this.index = 0;
      }
    },
    next() {
      this.index++;
      if (this.index >= this.list.length) {
        this.$message.error("已经是最后一页了");
        this.index = this.list.length - 1;
      }
    },
    toCourse() {
      this.$router.push("/course");
    },
    getMyCertificate() {
      this.$Loading.service({
        lock: true,
        text: "获取证书...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getMyCertificate({
        courseType: this.options.type,
        classYear: this.options.classYear,
      }).then((res) => {
        if (res.result) {
          this.list = [{ ...res.result }];
          this.$nextTick(() => {
            let url = `${window.location.origin}/h5/#/pages/newCertificate/index?ciphertext=${res.result.encryptText}&classYear=${this.options.classYear}`;
            if (window.location.href.indexOf("migrate") != -1) {
              url = `${window.location.origin}/migrate/h5/#/pages/newCertificate/index?ciphertext=${res.result.encryptText}&classYear=${this.options.classYear}`;
            }
            const canvas = this.$refs.certificateQrCanvas;
            QRCode.toCanvas(
              canvas,
              url,
              {
                width: 100,
                height: 100,
              },
              (error) => {
                if (error) console.error(error);
              }
            );
            this.$Loading.service().close();
          });
        } else {
          this.$Loading.service().close();
        }
      });
    },
    // 打印 =>
    print() {
      // 在打印前先隐藏水印
      const watermarkContainer = document.querySelector(".watermark-container");
      if (watermarkContainer) {
        watermarkContainer.style.display = "none";
      }

      html2canvas(this.$refs.printPdfpage).then((canvas) => {
        let saveUrl = canvas.toDataURL("image/png");

        // 打印完成后恢复水印显示
        if (watermarkContainer) {
          watermarkContainer.style.display = "block";
        }
        this.saveCertificateDownload();
        printJS({
          printable: [saveUrl],
          type: "image",
          style: `@media print { @page {size:auto; margin: 0} body{margin:0 5px}}`,
        });
      });
    },
    // 生成PDF
    generatePDF() {
      const element = this.$refs.printPdfpage;
      const pdfName = "证书-" + new Date().getTime() + ".pdf";

      // 在生成PDF前先隐藏水印
      const watermarkContainer = document.querySelector(".watermark-container");
      if (watermarkContainer) {
        watermarkContainer.style.display = "none";
      }

      this.saveCertificateDownload();
      html2canvas(element, {
        scale: 2, // 提高画布清晰度
        useCORS: true, // 允许跨域图片
        logging: false, // 不显示日志
        backgroundColor: null, // 保持透明背景
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        // 计算宽高比
        const imgWidth = 210; // A4宽度，单位mm
        const pageHeight = 297; // A4高度，单位mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        // 添加第一页
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        // 如果内容超过一页，添加新页
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        // 保存PDF
        pdf.save(pdfName);
        this.saveCertificateDownload();
        // PDF生成后恢复水印显示
        if (watermarkContainer) {
          watermarkContainer.style.display = "block";
        }
      });
    },
    // 保存证书下载记录
    saveCertificateDownload() {
      saveCertificateDownload({
        certificateCode: this.list[this.index].certificateCode,
      }).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.spanBox {
  // 首行文本缩进两个字符
  border-bottom: 2rpx solid #326496;
  margin: 0 5px;
  text-decoration: underline;
}

.zhanwu {
  display: block;
  text-align: center;
  line-height: 600px;
  color: rgb(107, 107, 107);
  font-size: 22px;

  span {
    color: red;
    cursor: pointer;
  }
}

.printPdfpage {
  position: relative;
  color: #000;

  .title {
    width: 700px;
    text-align: center;
    position: absolute;
    font-size: 32px;
    left: 50%;
    transform: translateX(-50%);
    top: 105px;
  }

  .row1 {
    width: 700px;
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    top: 255px;
  }

  .row2 {
    width: 700px;
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    top: 305px;
  }

  .row3 {
    width: 700px;
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    top: 355px;
  }

  .row4 {
    width: 700px;
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    top: 405px;
  }

  .row5 {
    width: 700px;
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    top: 455px;
  }

  .row6 {
    width: 700px;
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateX(-50%);
    top: 505px;
  }

  .name {
    width: 550px;
    text-align: justify;
    line-height: 42px;
    position: absolute;
    left: 400px;
    top: 325px;
    font-size: 18px;
    text-indent: 2em;
  }

  .infoLeft {
    text-align: left;
    position: absolute;
    left: 220px;
    top: 480px;
    font-size: 16px;
  }

  .head-photo {
    position: absolute;
    left: 220px;
    top: 340px;
    width: 100px;
    height: 100px;
    border: 1px solid #326496;
    padding: 5px;
  }

  .infoRight {
    position: absolute;
    text-align: center;
    right: 300px;
    top: 630px;
    font-size: 16px;
  }

  .stamp {
    position: absolute;
    right: 372px;
    top: 600px;
    width: 150px;
    height: 150px;
    border: 1px solid #326496;
    background: rgba(255, 0, 0, 0.5);
    border-radius: 150px;
    overflow: hidden;
  }

  .certificateQrCanvas {
    position: absolute;
    right: 260px;
    top: 280px;
    width: 100px;
    height: 100px;
  }
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.print {
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  background: #3078e1;
}

/* 水印样式 */
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}

.watermark {
  position: absolute;
  color: rgba(0, 0, 0, 0.2);
  font-size: 16px;
  transform: rotate(-30deg);
  user-select: none;
  white-space: nowrap;
  pointer-events: none;
}

/* 水印位置分布 - 调整为更合理的间距 */
@for $i from 1 through 12 {
  .watermark:nth-child(#{$i}) {
    top: ($i - 1) * 180px + 50px;
    left: (($i - 1) % 3) * 380px + 50px;
  }
}

.disabled {
  background: #ccc !important;
  cursor: not-allowed;
}

.pageTitle {
  display: flex;
  justify-content: space-between;
  color: #9b9b9b;
}
</style>
